// Code review - In Progress
// Documentation - In Progress
import GridPage from '../components/GridPage'
import { noOfReferencesHeader } from '../components/HeaderAttribute'
import { mainTable } from '../css/Common'
const NoOfReferencesPopup = ({ data }) => {
    


    return (
        <div class="w-full">
            <div class={mainTable.mainContentScreen}>
                <div class="p-2">
                    <GridPage

                        header={noOfReferencesHeader}

                        records={data}
                        addView={true}
                        tableHeight="h-60 overflow-y-auto"
                    />
                </div>
            </div>

        </div>
    )
}

export default NoOfReferencesPopup